/*
* project
*/
import client from '@js/modules/httpClient/index.js';

export default class ApplicationPolling {
  constructor() {
    this.$arrivalOrder = document.querySelector('[data-target="arrivalOrder"]');
    this.$order = document.querySelector('[data-target="order"]');
  }

  attachEvent() {
    if (document.forms.applications) {
      document.forms.applications.addEventListener('keypress', e => {
        if (e.keyCode == 13) {
          e.preventDefault();
          return false;
        }
      });
    }

    if(this.$arrivalOrder) {
      this.$arrivalOrder.addEventListener('click', () => {
        const projectSlug = this.$arrivalOrder.getAttribute('data-slug');
        document.forms.applications.submit();
        // submitが確実に完了してから実行
        setTimeout(() => {
          this.polling(projectSlug);
        }, 1000);
      });
    } else if (this.$order) {
      this.$order.addEventListener('click', () => {
        document.forms.applications.submit();
      });
    }
  }

  async polling(projectSlug) {
    const POLLING_INTERVAL_TIME = 3000;
    try {
      const response = await client.get(`/projects/${projectSlug}/applications/result_url`);
      const redirectUrl = response.data.url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
      await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL_TIME));
      await this.polling(projectSlug);
    } catch {
      await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL_TIME));
      await this.polling(projectSlug);
    }
  }
}
